function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { useClassPrepend } from "../../../index";
import "./skeletonLoader.css";
const SkeletonLoader = ({
  classPrepend = "styled",
  className = "",
  height = "1rem",
  width = "100%",
  style = {},
  ...rest
}) => {
  const [getClassName, getClassNameWithGlobal, getClassNameValue] = useClassPrepend(classPrepend);
  return /*#__PURE__*/React.createElement("div", _extends({}, getClassNameWithGlobal(`skeleton-loader-container ${className}`), {
    style: {
      height,
      width,
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", _extends({}, getClassNameWithGlobal(`skeleton-loader-mask ${className}`), {
    style: {
      height,
      width
    }
  }), /*#__PURE__*/React.createElement("div", getClassNameWithGlobal(`skeleton-loader-gradient ${className}`))));
};
export { SkeletonLoader };